import { render, staticRenderFns } from "./code-postaux-list.vue?vue&type=template&id=092c606a&"
import script from "./code-postaux-list.vue?vue&type=script&lang=js&"
export * from "./code-postaux-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports